/* Hero carousel — sections/hero-banner.liquid with one or more Slide blocks.
   ---------------------------------------------------------------------------
   Slide 1 is the section's own media and copy, exactly as before (its video
   is still started by rb-hero-video.js). Slides 2–4 ship with data-* only;
   this file hydrates a slide just before it is shown, so slide 1 stays the
   only eager media and the LCP is unchanged.

   - Crossfade, one slide visible; the rest are aria-hidden and inert, so
     their links cannot be tabbed to.
   - Dots at every size; arrows at desktop when the section enables them;
     swipe on touch.
   - Auto-rotate (section setting) on a fixed interval for every slide, video
     included. Pauses while hovered or focused, and has a visible pause button
     (WCAG 2.2.2: anything that moves on its own for more than 5s needs one).
   - prefers-reduced-motion: no auto-rotate and no fade (CSS); videos do not
     play (the section's CSS hides them).
   - A slide's video plays only while that slide shows. */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function hydrate(slide) {
    if (!slide || slide.hasAttribute('data-hydrated')) return;
    slide.setAttribute('data-hydrated', '');
    [].forEach.call(slide.querySelectorAll('source[data-srcset]'), function (s) { s.srcset = s.getAttribute('data-srcset'); });
    [].forEach.call(slide.querySelectorAll('img[data-src]'), function (img) {
      if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
      img.src = img.getAttribute('data-src');
    });
  }

  function videoOf(slide) { return slide.querySelector('video[data-hero-slide-video], video[data-hero-video]'); }

  function playIn(slide) {
    var v = videoOf(slide);
    if (!v || REDUCED.matches) return;
    if (v.hasAttribute('data-hero-slide-video')) {
      var src = (DESKTOP.matches ? v.getAttribute('data-desktop-src') : v.getAttribute('data-mobile-src')) ||
        v.getAttribute('data-mobile-src') || v.getAttribute('data-desktop-src');
      if (src && v.getAttribute('data-src-set') !== src) { v.setAttribute('data-src-set', src); v.src = src; }
    }
    if (v.src || v.currentSrc) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
  }
  function pauseIn(slide) { var v = videoOf(slide); if (v && !v.paused) v.pause(); }

  function init(root) {
    if (root.__rbHc) return;
    root.__rbHc = true;
    var slides = [].slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll('[data-hero-dot]'));
    var pauseBtn = root.querySelector('[data-hero-pause]');
    var seconds = Math.max(2, Number(root.getAttribute('data-interval')) || 6);
    var auto = root.getAttribute('data-autoplay') === 'true' && !REDUCED.matches;
    var idx = 0, timer = null, hovering = false, focused = false, userPaused = false;

    if (!auto && pauseBtn) pauseBtn.hidden = true;

    function show(i) {
      i = (i + slides.length) % slides.length;
      if (i === idx && slides[i].classList.contains('is-active')) return;
      hydrate(slides[i]);
      hydrate(slides[(i + 1) % slides.length]);   // ready before it is needed
      slides.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
        if (!on) pauseIn(s);
      });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      playIn(slides[i]);
      idx = i;
      schedule();
    }

    function schedule() {
      clearTimeout(timer);
      if (!auto || userPaused || hovering || focused) return;
      timer = setTimeout(function () { show(idx + 1); }, seconds * 1000);
    }

    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
    var prev = root.querySelector('[data-hero-prev]'), next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      userPaused = !userPaused;
      pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.getAttribute('data-label-play') : pauseBtn.getAttribute('data-label-pause'));
      root.classList.toggle('hero--paused', userPaused);
      schedule();
    });

    /* Hover means a real mouse: a tap on a phone fires compatibility
       mouseenter with no mouseleave until the next tap elsewhere, which
       would stop the rotation for good after one dot tap. Likewise focus
       pauses only when it is keyboard focus (:focus-visible) — tapping a
       dot focuses it on Android. */
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; clearTimeout(timer); } });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovering = false; schedule(); } });
    root.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (err) {}
      if (kb) { focused = true; clearTimeout(timer); }
    });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focused = false; schedule(); } });

    /* Swipe: a horizontal move of 40px+ that is more sideways than down. */
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* The second slide is fetched only once the page has finished loading,
       so it never competes with slide 1. */
    if (document.readyState === 'complete') hydrate(slides[1]);
    else window.addEventListener('load', function () { hydrate(slides[1]); }, { once: true });

    schedule();
  }

  function run(scope) { [].forEach.call((scope || document).querySelectorAll('[data-hero-carousel]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }, { once: true });
  else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-hero-carousel]');
    if (!root) return;
    var slides = [].slice.call(root.querySelectorAll('[data-hero-slide]'));
    var i = slides.indexOf(e.target.closest('[data-hero-slide]'));
    var dot = root.querySelectorAll('[data-hero-dot]')[i];
    if (dot) dot.click();
  });
})();
